// import { bindActionCreators }  from 'redux';
import axios from 'axios';

import { bindActionCreators } from 'redux'

export function axiosConfig (store) {
  const messageAction = bindActionCreators(require('../actions/message'), store.dispatch)
  const globalActions = bindActionCreators(require('../actions/global'), store.dispatch)

  axios.defaults.withCredentials = false

  // Request Interceptors
  axios.interceptors.request.use(function (config) {
    const mf_authorization = JSON.parse(localStorage.getItem('mf_authorization'))
    const token = mf_authorization && mf_authorization.access_token && mf_authorization.access_token.token
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token;
    }

    return config;
  }, function (error) {
    // Do something with request error
    return Promise.reject(error);
  });

  // Add a response interceptor
  axios.interceptors.response.use((response) => {
    if (response.config.method.toLowerCase() !== "get")
      messageAction.setMessage(response.data.meta)

    return response
  });

  // Response Interceptors
  axios.interceptors.response.use(null, function (error) {
    const response = error.response;
    if (response) {
      switch (response.status) {
        case 401:
          localStorage.removeItem('mf_authorization');
          window.location.href = "/login"
          break;
        case 403: // bad request
        case 409: // conflict
        case 500:
          if (response.config.method.toLowerCase() !== "get")
            messageAction.setMessage(response.data.meta)
          break
        case 503: // Service Unavailable
          window.location.href = "/under-maintenance"
          break
        case 504:
          globalActions.setErrorStatus(response.status)
          break
        default:
      }
    } else {
      // handling Network Error - https://github.com/axios/axios/issues/383
      globalActions.setErrorStatus(504)
    }

    globalActions.setGlobalFailure(error.response);
    return Promise.reject(response);
  });
}
